function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 473.931 473.931",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D62127"
    },
    cx: 236.966,
    cy: 236.966,
    r: 236.966
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CA842A"
    },
    points: "193.247,188.854 67.464,167.384 162.089,235.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CA842A"
    },
    points: "278.623,188.854 404.409,167.384 309.777,235.08  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB20F"
    },
    d: "M404.293,167.384c0,0-88.53,52.115-94.629,46.02c-6.78-6.773-65.922-115.104-74.424-115.141 c-8.494,0.041-66.371,108.373-73.155,115.141c-6.092,6.095-94.622-46.02-94.622-46.02C55.576,173.895,130,358.644,130,358.644 c0,14.784,11.985,26.769,26.765,26.769h78.48h79.748c14.78,0,26.765-11.985,26.765-26.769 C341.754,358.644,416.177,173.895,404.293,167.384z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC50B"
    },
    d: "M235.241,98.262c-8.494,0.041-66.371,108.373-73.155,115.141 c-6.092,6.095-94.622-46.02-94.622-46.02C55.576,173.895,130,358.644,130,358.644c0,14.784,11.985,26.769,26.765,26.769h78.48 V98.262H235.241z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC50B"
    },
    cx: 234.597,
    cy: 98.262,
    r: 25.706
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8972F"
    },
    d: "M342.113,358.644c0,14.784-11.985,26.769-26.772,26.769H156.765 c-14.78,0-26.765-11.985-26.765-26.769c0,0,61.694-3.674,105.896-3.674C280.101,354.97,342.113,358.644,342.113,358.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4A12E"
    },
    d: "M235.241,385.416h-78.476c-14.78,0-26.765-11.985-26.765-26.769c0,0,61.694-3.674,105.896-3.674 L235.241,385.416z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6E568"
    },
    d: "M213.763,103.359c-4.516-4.516,0.438-17.021,4.962-21.541c4.516-4.513,15.45-8.801,19.966-4.284 C243.207,82.049,218.283,107.879,213.763,103.359z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC50B"
    },
    cx: 404.746,
    cy: 168.679,
    r: 16.898
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC50B"
    },
    d: "M391.051,172.046c-2.967-2.971,0.288-11.195,3.259-14.163c2.967-2.967,10.159-5.785,13.126-2.818 C410.408,158.037,394.026,175.017,391.051,172.046z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC50B"
    },
    cx: 67.165,
    cy: 168.679,
    r: 16.898
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6E568"
    },
    d: "M53.459,172.046c-2.967-2.971,0.292-11.195,3.259-14.163c2.975-2.967,10.159-5.785,13.134-2.818 C72.818,158.037,56.433,175.017,53.459,172.046z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A8213B"
    },
    points: "234.908,210.298 205.441,262.514 234.908,314.731 264.367,262.514 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#951D38"
    },
    points: "205.441,262.514 234.908,314.731 264.367,262.514 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C0355A"
    },
    points: "234.908,210.298 205.441,262.514 234.908,314.731 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B72D4C"
    },
    points: "234.908,262.514 205.441,262.514 234.908,314.731 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.b04ed14dd46305983d94af2eb2c8058e.svg";
export { ForwardRef as ReactComponent };